import { render, staticRenderFns } from "./LeadStateControl.vue?vue&type=template&id=98051020&"
import script from "./LeadStateControl.vue?vue&type=script&lang=js&"
export * from "./LeadStateControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports